<template>
    <div id="axis-chart" ref="chartdiv"></div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);


    export default {
        name: 'AxisChart',
        props: ['data'],
        data() {
            return {
                chart: null,
                colors: [
                    '#000000',
                    '#ff0000',
                    '#25b565',
                    '#488df5',
                    '#a1493c',
                    '#7f3ca1',
                    '#3c93a1',
                    '#c32868'
                ],
            }
        },
        computed: {
            chart_data: {
                get: function() {
                    return this.data;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            setupChart() {
                this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
                this.chart.data = this.chart_data.items;

                // Create category axis
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "date";
                categoryAxis.renderer.opposite = true;

                // Create value axis
                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.inversed = false;
                valueAxis.title.text = this.chart_data.name;
                valueAxis.renderer.minLabelPosition = 0.01;

                // Create series (lines)
                if(this.chart_data && this.chart_data.items && this.chart_data.items.length > 0) {
                    let headers = Object.keys(this.chart_data.items[0]);

                    headers.map((item, index) => {
                        let date_field = headers[0];

                        if(index > 0) {
                            let series1 = this.chart.series.push(new am4charts.LineSeries());
                            series1.dataFields.valueY = item; //code here
                            series1.dataFields.categoryX = date_field;
                            series1.name = item; //name here
                            series1.strokeWidth = 3;
                            series1.bullets.push(new am4charts.CircleBullet());
                            series1.tooltipText = "{date}, {name}: {valueY} "+this.chart_data.unit;
                            series1.legendSettings.valueText = "{valueY}";
                            series1.visible  = false;

                            let color = '#000000';

                            if(this.colors[index]) {
                                color = this.colors[index];
                            }

                            series1.fill = am4core.color(color);
                            series1.stroke = am4core.color(color);
                        }
                    });
                }

                // Add chart cursor
                this.chart.cursor = new am4charts.XYCursor();
                this.chart.cursor.behavior = "zoomY";

                // Add legend
                this.chart.legend = new am4charts.Legend();
            }
        },
        mounted() {
            if(this.chart_data) {
                this.setupChart();
            }
        },
        watch: {
            data: function(newVal) {
                this.chart_data = newVal;

                if(this.chart_data) {
                    this.setupChart();
                }
            },
        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hello {
        width: 100%;
        height: 400px;
    }
</style>
